import $ from 'jquery';

export const registerJQuery = () => {
    window.jQuery = $;
    window.$ = $;
    require('jquery-ui-sortable');

    // for more info on formbuilder integration
    // see: https://github.com/kevinchappell/formBuilder/issues/670#issuecomment-347503006
};